<app-filter-panel [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Online Status -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "SESSIONSTATUS" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let status of meterStatuses">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-online-' + status">
            <input type="checkbox" [id]="'checkbox-online-' + status"
              [checked]="draftMeterStatus == status"
              (change)="onMeterStatusChange(status)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-online-' + status">{{ status.toUpperCase() | translate }}</label>
        </div>
      </div>
    </div>
  </div>
</app-filter-panel>
